'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = selectors;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function selectors(target) {
  var prefix = 'rcw-chart';
  target.selectors = (0, _extends3.default)({}, target.selectors, {
    wrapper: prefix + '__wrapper',
    chart: prefix + '__chart',
    tooltip: prefix + '__tooltip',
    base: prefix + '__base'
  });
}